import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useState } from "react";
export function useClientLoaded() {
  const $ = _c(4);
  const [clientLoaded, setClientLoaded] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setClientLoaded(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[2] !== clientLoaded) {
    t2 = {
      clientLoaded
    };
    $[2] = clientLoaded;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}